import { render, staticRenderFns } from "./CamerataActivityUser.vue?vue&type=template&id=07ff8b28"
import script from "./CamerataActivityUser.vue?vue&type=script&lang=js"
export * from "./CamerataActivityUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports